import { isDev, usesFirebaseEmulator } from "shared/constants/Environment";

export interface LaunchDarklyFeatureFlags {
  operationalThemaVersion: string;
  flagsAuthLoaded: boolean;
  evaluation: boolean;
  cancelEvaluation: boolean;
  operationalMaintenanceMode: boolean;
  inactiveBooksFilter: boolean;
  useElasticsearchHybridSearch: boolean;
  operationalAmazonRankKeywordsLimiter: boolean;
  useFeSearchTerms: boolean;
  guidedSemanticSearch: boolean;
  showAPlusTab: boolean;
  amplifyProjects: boolean;
  essenceIntegration: boolean;
  uploadManuscript: boolean;
  uploadManuscriptTeaser: boolean;
}

export function parseFeatureFlags(flags: Partial<LaunchDarklyFeatureFlags>) {
  const mergedFlags = { ...flags, ...window.e2e?.featureFlags };
  return {
    operationalThemaVersion: mergedFlags.operationalThemaVersion ?? "-",
    flagsAuthLoaded: mergedFlags.flagsAuthLoaded ?? false,
    evaluation: mergedFlags.evaluation ?? false,
    cancelEvaluation: mergedFlags.cancelEvaluation ?? false,
    maintenanceMode: mergedFlags.operationalMaintenanceMode ?? false,
    inactiveBooksFilter: mergedFlags.inactiveBooksFilter ?? true,
    useElasticsearchHybridSearch:
      mergedFlags.useElasticsearchHybridSearch ?? false,
    operationalAmazonRankKeywordsLimiter:
      mergedFlags.operationalAmazonRankKeywordsLimiter ?? false,
    useFeSearchTerms: mergedFlags.useFeSearchTerms ?? true,
    guidedSemanticSearch: mergedFlags.guidedSemanticSearch ?? false,
    showAPlusTab: mergedFlags.showAPlusTab ?? false,
    amplifyProjects: mergedFlags.amplifyProjects ?? false,
    essenceIntegration:
      (isDev && usesFirebaseEmulator) ||
      (mergedFlags.essenceIntegration ?? false),
    uploadManuscript: mergedFlags.uploadManuscript ?? false,
    uploadManuscriptTeaser: mergedFlags.uploadManuscriptTeaser ?? false,
  };
}

export type FeatureFlags = ReturnType<typeof parseFeatureFlags>;
